import { EventTypes } from '@candulabs/craft';
import { useEffect } from 'react';

import { BuiltInComponents } from 'craft/constants';
import { useEditor, useSelection } from 'craft/hooks';

import { useForm } from './useForm';

export const useFormSelectionManager = (nodeId: string) => {
  const { actions, query } = useEditor();
  const { activeStepId, isMultistepForm } = useForm(nodeId);

  const { all } = useSelection().selection;

  // if navigation shortcuts lands us on a formStepId that is different than the one currently set
  useEffect(() => {
    if (all.length !== 1) {
      return;
    }
    const formStepNodeId = [all[0], ...query.node(all[0]).ancestors(true)]?.find(
      (n) => query.node(n)?.get()?.data?.name === BuiltInComponents.FormStep,
    );

    if (!formStepNodeId || isMultistepForm) {
      return;
    }

    const selectedNodeFormStepId = query.node(formStepNodeId).get().data.props.stepId;

    if (selectedNodeFormStepId === activeStepId) {
      return;
    }
    /**
     *  if a selected node has a formStepId different to the state one,
     *  the state one should be used instead for re-selecting the proper formStep node last deep descendant
     *  */
    const formElement = query.node(formStepNodeId).getParent();
    const correspondingFormStepToSelect = formElement
      .descendants()
      .find((node) => query.node(node).get().data.props.stepId === activeStepId);

    const lastItemOfSelectedFormStep = query.node(correspondingFormStepToSelect)?.descendants(true);
    if (correspondingFormStepToSelect) {
      actions.setEventNodes(
        EventTypes.selected,
        lastItemOfSelectedFormStep[lastItemOfSelectedFormStep.length - 1],
      );
    }
  }, [all, query, activeStepId, isMultistepForm]);
};
